import { useEffect, useState } from 'react';

import { Divider, Typography } from '@cobliteam/ui/components';

import { type ChatHistory, FeedbackOption } from '@cobliteam/api-lib';

import { Analytics } from '@cobliteam/analytics';

import { useGetChatHistory, useGiveChatFeedback } from '@cobliteam/hooks/src/useEntity/useCoblinator';

import Icon from '@cobliteam/ui/icons';

import Alert from '@cobliteam/ui/components/Alert';
import ChipGroup, { ChipGroupProvider } from '@cobliteam/ui/components/ChipGroup';

const ChatItemFeedback = ({
  selectedAIResponse,
}: {
  selectedAIResponse: ChatHistory | undefined;
}) => {
  const [currentFeedback, setCurrentFeedback] = useState<FeedbackOption | undefined>(undefined);

  useEffect(() => {
    setCurrentFeedback(selectedAIResponse?.feedback);
  }, [selectedAIResponse]);

  const { mutateAsync: giveChatFeedback } = useGiveChatFeedback();
  const { refetch: refetchChatHistory } = useGetChatHistory();

  if (!selectedAIResponse) {
    return null;
  }

  const handleFeedback = (feedback: FeedbackOption) => async () => {
    try {
      setCurrentFeedback(feedback);
      Analytics.track('Coblinator Chat Feedback', { feedback });
      await giveChatFeedback({
        chatHistoryId: selectedAIResponse.id,
        feedback,
      });
      refetchChatHistory();
    } catch (error) {
      Analytics.track('Coblinator Chat Feedback Error', { error });
      Alert.error('Erro ao enviar opinião. Tente novamente mais tarde.');
    }
  };

  return (
    <div className='mt-auto mb-0 flex flex-col'>
      <Divider />
      <div className='mt-5 flex items-center gap-3 self-center'>
        <Typography variant='input-text' color='secondary' className='italic'>
          O que você achou da resposta?
        </Typography>

        <ChipGroupProvider type='single' value={currentFeedback}>
          <ChipGroup
            value={FeedbackOption.CORRECT}
            icon={<Icon name='check' size='sm' className='mr-2 text-gray' />}
            variant='outlined'
            color='primary'
            onClick={handleFeedback(FeedbackOption.CORRECT)}
          >
            Correta
          </ChipGroup>

          <ChipGroup
            value={FeedbackOption.INCORRECT}
            icon={<Icon name='x' size='sm' className='mr-2 text-gray' />}
            variant='outlined'
            color='primary'
            onClick={handleFeedback(FeedbackOption.INCORRECT)}
          >
            Incorreta
          </ChipGroup>

          <ChipGroup
            value={FeedbackOption.INCOMPLETE}
            icon={<Icon name='ban' size='sm' className='mr-2 text-gray' />}
            variant='outlined'
            color='primary'
            onClick={handleFeedback(FeedbackOption.INCOMPLETE)}
          >
            Incompleta
          </ChipGroup>
        </ChipGroupProvider>
      </div>
    </div>
  );
};

export default ChatItemFeedback;
